<template>
  <main class="complaint-page">
    <header class="topbar">
      <a class="record-link" href="javascript:;" @click="$router.push({name:'tousujilu'})">
        <span>投诉记录</span>
        <svg viewBox="0 0 12 12" aria-hidden="true">
          <path d="M3.5 2l5 4-5 4" fill="none" stroke="rgba(153,153,153,1)" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </a>
    </header>

    <section class="card">
      <label class="field"><span class="label">iccid/短号</span><input type="text" v-model="form.iccid"></label>
      <label class="field"><span class="label">联系人</span><input type="text" v-model="form.name"></label>
      <label class="field"><span class="label">联系电话</span><input type="text" v-model="form.mobile"></label>
    </section>

    <section class="card">
      <label class="field textarea-field">
        <span class="label">问题描述</span>
        <textarea v-model="form.desc"></textarea>
      </label>
    </section>

    <section class="card attachment-card">
      <h2 class="label attachment-title">附件</h2>
      <div class="attachment-row">
        <van-uploader v-model="fileList" preview-size="1.02rem" :max-count="6" multiple>
          <button class="upload-btn" type="button" aria-label="添加附件">
            <img src="./static/images/complaint/shangchuan.png" alt="">
          </button>
        </van-uploader>
      </div>
    </section>

    <button class="submit-btn" type="button" @click="handleBindCard">提交反馈</button>
  </main>
</template>

<script>
export default {
  name: "feedbackNew",
  data () {
    return { customerServiceInfo: {}, form: {}, fileList: [], posting: false }
  },
  methods: {
    handleBindCard () {
      if (this.posting) return
      this.posting = true
      this.$toast.loading("提交中")
      const files = this.fileList.map((f) => f.file)
      this.upload("/user/feedback", files, this.form, (res) => {
        this.$toast.clear()
        this.posting = false
        if (res.code) {
          this.$toast.success(res.msg)
          this.$router.back()
        } else {
          this.$toast(res.msg)
        }
      })
    },
    getCustomerServiceInfo () {
      this.fetchData("/config/getCustomerServiceInfo", {}, (res) => {
        if (res.code) this.customerServiceInfo = res.data
      })
    }
  },
  created () {
    this.getCustomerServiceInfo()
    if (this.$route.query.iccid) this.form.iccid = this.$route.query.iccid
  }
}
</script>

<style scoped src="./static/css/complaint.css"></style>
<style scoped>
.complaint-page {
  --page-bg: #f5f6f7;
  --card-bg: #ffffff;
  --field-bg: #ffffff;
  --border: #cccccc;
  --text-main: #1f1f1f;
  --button-blue: #249cf7;
  background: var(--page-bg);
}
</style>



// WEBPACK FOOTER //
// src/newpage/feedback.vue